






















































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { IUser, EUserStatus, EUserGroup } from "@/components/shared/types";
import { User } from "@/components/User";
import { L } from "@/common/filters";
import { isString, isObject, isEmptyObject, sortObjectArray } from "@/common/utils";
import { ICodeList } from "@/components/map/types"
const AddressMapping = {
    hrn_pk: 'addrHrn',
    door_no: 'addrNo',
    vill_no: 'addrMoo',
    vill_th: 'addrVill',
    floor_nn: 'addrFloor',
    building_th: 'addrBuilding',
    alley_th: 'addrAlley',
    street_th: 'addrStreet',
    addr_aa3: 'addrProvince',
    addr_aa4: 'addrCounty',
    addr_aa5: 'addrTown',
    zip_code: 'addrZipCode'
  };

@Component
export default class AddUser extends Vue {
  FARMER:EUserGroup = EUserGroup.Citizens;
  showMini:boolean = true;

  name:string = null;
  surname:string = null;
  nationalId:string = null;
  mobileNo:string = null;
  email:string = null;

  organization:string | ICodeList = null;
  orgInitials:string = null;
  
  addrHrn:number = null;
  addrNo:string = null;
  addrMoo:string = null;
  addrVill:string = null;
  addrBuilding:string = null;
  addrFloor:number = null;
  addrAlley:string = null;
  addrStreet:string = null;
  addrProvince:number = null;
  addrCounty:number = null;
  addrTown:number = null;
  addrZipCode:number = null;

  userId:string = null;
  password:string = null;
  password2:string = null;
  userGroup:EUserGroup = EUserGroup.Operators;
  usergroups:ICodeList[] = [];

  organizations:ICodeList[] = [];
  Provinces: ICodeList[] = [];
  addrCounties: ICodeList[] = [];
  addrTowns: ICodeList[] = [];

  aorProvince:number = null;
  aorCounty:number = null;
  aorTown:number = null;
  aorCounties: ICodeList[] = [];
  aorTowns: ICodeList[] = [];

  ssnChecking:boolean = false;
  emailChecking:boolean = false;
  mobileChecking:boolean = false;
  usernameChecking:boolean = false;
  ssnError:string[] = [];
  emailError:string[] = [];
  mobileError:string[] = [];
  usernameError:string[] = [];

  async checkAvailability(name:"ssn" | "email" | "mobile" | "username",value:string) {
    this[name + 'Error'] = [];
    if (value) {
      this[name + 'Checking'] = true;
      try {
        let parmas = {};
        parmas[name] = value;
        let available = await this.User.requestResource('user/availability', 'GET', parmas);
        if (!available[name]) {
          this[name + 'Error'].push(L('alreadyRegistered'));
        } else if (name=='ssn') {
          await this.fetchPerson();
        }
      } catch (error) {
        this[name + 'Error'].push(error.message || 'Check Error');
      }
      this[name + 'Checking'] = false;
    }
  }

  get rules () {
    return {
      required: value => {
        value = value ? (value+'').trim() : null;
        return !!value || L('required');
      },
      email: value => {
        let valid:boolean = this.User.validateEmail(value);
        this.emailError = [];
        if (valid) {
          this.checkAvailability('email',value);
        }
        return valid || L('invalidEmail');
      },
      username: value => {
        value = value ? (value+'').trim() : null;
        let valid:boolean = !!value && (value.length>=4);
        this.usernameError = [];
        if (valid) {
          this.checkAvailability('username',value);
        }
        return valid || L(!value ? 'required' : 'invalidUsername');
      },
      password: value => {
        //allow password to contain space
        return (!!value && value.length>=6) || L(!value ? 'required' : 'invalidPassword');
      },
      password2: value => {
        return ((!!value || !!this.password) && value==this.password) || 
                L(!value ? 'required' : 'passwordNotTheSame');
      },
      ssn: value => {
        this.ssnError = [];
        value = value ? (value+'').trim() : null;
        let valid = this.User.validateThaiId(value);
        if (valid) {
          this.checkAvailability('ssn',value);
        } else {
          valid = !value && (this.userGroup!=EUserGroup.Citizens);
        }
        return valid || L(!value ? 'required' : 'invalidSSN');
      },
      mobile: value => {
        this.mobileError = [];
        value = value ? (value+'').trim() : null;
        if (!value) return true;
        let valid:boolean = !!value && (value.length==10);
        if (valid) {
          this.checkAvailability('mobile',value);
        }
        return valid || L(!value ? 'required' : 'invalidMobileNo');
      },
      orgName: value=> {
        if (!!value && isString(value)) {
          value = (value+'').trim();
        }
        return (this.userGroup==EUserGroup.Citizens) || !!value || L('required');
      },
      orgCode: value=> {
        value = value ? (value+'').trim() : null;
        return (this.userGroup==EUserGroup.Citizens) || !!value || L('required');
      }
    }
  }

  created() {
    this.resetForm();
    this.fetchUserGroups();
    this.fetchOrganizations();
    this.fetchProvinces();
  }

  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.validateForm();
  }

  resetForm() {
    if (this.User.isSuperAdmins) {
      this.userGroup = EUserGroup.Operators;
      this.organization = null;
      this.orgInitials = null;
    } else {
      if (this.User.OrgCode.match(/DOAE/i)) {
        this.userGroup = EUserGroup.Operators;
      } else {
        this.userGroup = EUserGroup.OperatorsOthers;
      }
    }
    
    this.organization = {
      code: this.User.Organization.Code,
      name: this.User.Organization.Name
    };
    this.orgInitials = this.User.Organization.Abbr;

    this.userId = null;
    this.password = null;
    this.password2 = null;

    this.name = null;
    this.surname = null;
    this.nationalId = null;
    this.mobileNo = null;
    this.email = null;
    
    this.ssnChecking = false;
    this.emailChecking = false;
    this.mobileChecking = false;
    this.usernameChecking = false;
    this.ssnError = [];
    this.emailError = [];
    this.mobileError = [];
    this.usernameError = [];

    this.aorProvince = null;
    this.aorCounty = null;
    this.aorTown = null;

    for (let p in AddressMapping) {
      this[AddressMapping[p]] = null;
    }
  }

  get orgHasChanged() : boolean {
    let changed, v;
    if (!!this.organization) {
      if (isObject(this.organization)) {
        changed = true;
      } else {
        v = (<string>this.organization).trim();
        changed = !!v;
      }
    } else if (!!this.orgInitials) {
      v = this.orgInitials.trim();
      changed = !!v;
    }
    return changed;
  }

  get addressHasChanged() : boolean {
    let changed:boolean = false;
    let v;
    for (let p in AddressMapping) {
      if (p!='hrn_pk') {
        if (!!this[AddressMapping[p]]) {
          v = (this[AddressMapping[p]] + '').trim();
          if (!!v) {
            changed = true;
            break;
          }
        }
      }
    }
    return changed;
  }

  get hasValidUserInput() : boolean {
    return !!this.name && !!this.surname && 
           !!this.userId && this.userId.trim().length>=4 && 
           !!this.password && this.password.length>=6 && this.password==this.password2 && 
           (!this.mobileNo || (this.mobileNo && this.User.validateMobile(this.mobileNo))) && 
           (!this.nationalId || (this.nationalId && this.User.validateThaiId(this.nationalId+''))) &&
           this.User.validateEmail(this.email) &&
           !this.ssnChecking && this.ssnError.length==0 &&
           !this.emailChecking && this.emailError.length==0 &&
           !this.mobileChecking && this.mobileError.length==0;
  }
  
  get hasChanged() : boolean {
    return this.hasValidUserInput;
  }

  get User() : User {
    return this.$store.getters.User;
  }

  get language() : string {
    return this.$store.getters.Language;
  };

  async fetchUserGroups() {
    try {
      let url = 'codelist/user_group_' + this.language;
      if (this.User.isAdmins) {
        if (this.User.OrgCode.match(/^DOAE/i)) {
          url += '_doae';
        } else {
          url += '_others';
        }
      }
      let data = await this.User.requestResource(url);
      this.usergroups = data.map((d) => {
        return d;
      });
      sortObjectArray(this.usergroups,'code');
    } catch (error) {}
  };

  async fetchPerson() {
    let address = {};
    let validate = this.$refs.form['validate'];
    try {
      if (this.nationalId) {
        let farmers = await this.User.requestResource('mis/farmer/' + this.nationalId);
        let farmer = farmers[0];
        this.name = farmer.name_th;
        this.surname = farmer.surname_th;
        if (farmer.mobile) {
          this.mobileNo = farmer.mobile;
          this.rules.mobile(this.mobileNo);
        }
        if (farmer.email) {
          this.email = farmer.email;
          this.rules.email(this.email);
        }
        address = farmer.address || {};
      }
    } catch (error) {}
    if (this.userGroup==EUserGroup.Citizens) {
      for (let p in AddressMapping) {
        this[AddressMapping[p]] = address[p] || null;
      }
    }
  }

  async fetchOrganizations() {
    try {
      let data:any = null;
      if (this.User.isAdmins) {
        data = {
          o: this.User.OrgCode
        };
      }
      data = await this.User.requestResource('codelist/organization_' + this.language, 'GET', data);
      this.organizations = data.map((d) => {
        return d;
      });
      if (isObject(this.organization) && this.organization['code']) {
        let org = null;
        for (let i=0; i<this.organizations.length; i++) {
          if (this.organizations[i]['code'] == this.organization['code']) {
            org = this.organizations[i];
            break;
          }
        }
        if (org && org.code != this.organizations['code']) {
          this.organization = org;
        }
      }
      this.onOrganizationChange();
    } catch (error) {}
  };

  async fetchProvinces() {
    try {
      if (this.Provinces && this.Provinces.length>0) return;
      let data = await this.User.requestResource('codelist/province');
      this.Provinces = data.map((d) => {
        return d;
      });
    } catch (error) {
    }
  };

  async fetchCounties(what?:"addr" | "aor") {
    what = what || 'addr';
    try {
      let exists:boolean = false;
      this[what+'Counties'] = [];
      this[what+'Towns'] = [];
      if (this[what+'Province']) {
        let data = await this.User.requestResource('codelist/amphoe/' + this[what+'Province']);
        this[what+'Counties'] = data.map((d) => {
          exists = exists || (this[what+'County']==d.code);
          return d;
        });
      }
      if (!this[what+'Province'] || !exists) {
        this[what+'County'] = null;
        this[what+'Town'] = null;
        if (what=='addr') {
          this.addrZipCode = null;
        }
      }
    } catch (error) {
    }
  };

  async fetchTowns(what?:"addr" | "aor") {
    what = what || 'addr';
    try {
      let exists:boolean = false;
      this[what+'Towns'] = [];
      if (this[what+'County']) {
        let data = await this.User.requestResource('codelist/tambon/' + this[what+'County']);
        this[what+'Towns'] = data.map((d) => {
          exists = exists || (this[what+'Town']==d.code);
          return d;
        });
      }
      if (!this[what+'County'] || !exists) {
        this[what+'Town'] = null;
      }
      if (what=='addr' && !this.addrTown) {
        this.addrZipCode = null;
      }
    } catch (error) {
    }
  };

  async onOrganizationChange() {
    let address = {};
    if (isString(this.organization) || !this.organization) {
      this.organization = !!this.organization ? (this.organization+'').trim() : null;
      this.orgInitials = null;
      for (let p in AddressMapping) {
        this[AddressMapping[p]] = null;
      }
    } else if (isObject(this.organization) && this.organization['code']) {
      this.orgInitials =  this.organization['abbr'];
      try {
        address = await this.User.requestResource('mis/organization_' + this.language + '/' + this.organization['code']);
        address = address[0].address || {};
      } catch (error) {
        address = {}
      }
      for (let p in AddressMapping) {
        this[AddressMapping[p]] = address[p] || null;
      }
    }
  }
  
  async onUserGroupChange() {
    try {
      if (this.userGroup==EUserGroup.Citizens) {
        await this.fetchPerson();
      } else {
        await this.fetchOrganizations();
      }
    } catch (error) {}
    this.validateForm();
  }

  onProvinceChange(what?:"addr" | "aor") {
    this.fetchCounties(what);
  };

  onCountyChange(what?:"addr" | "aor") {
    this.fetchTowns(what);
  };

  onTownChange(what?:"addr" | "aor") {
    what = what || 'addr';
    if (this.addrTown) {
      for (let i=0; i<this.addrTowns.length; i++) {
        if ((this.addrTowns[i].code==this.addrTown) && this.addrTowns[i].zip_code) {
          this.addrZipCode = parseInt(this.addrTowns[i].zip_code+'');
        }
      }
    } else {
      this.addrZipCode = null;
    }
  }

  async validateForm() {
    try {
      let form = this.$refs.form;
      if (form['validate']) {
        await form['validate'](); // this is a Promise
      }
    } catch (error) {}
  }

  async saveUser() {
    try {
      this.$store.commit('notifyChange', {
        Dialog: {
          Type: 'info',
          Title: 'registerUsers',
          OkText: null,
          CancelText: 'close',
          wait: true,
          OnClose: null
        }
      });
      let me:User = new User({
        GivenName: this.name,
        Surname: this.surname
      });

      let method:"POST" | "PUT";
      let address:{[key:string] : any} = {};
      for (let p in AddressMapping) {
        if (!p.match(/addr_aa3|addr_aa4|addr_aa5|hrn_pk/) && this[AddressMapping[p]]) {
          address[p] = this[AddressMapping[p]];
        }
      }
      let aac = this.addrTown || this.addrCounty || this.addrProvince;
      if (!!aac) {
        address['aac5_fk'] = aac;
      }
      if (!isEmptyObject(address)) {
        address.user_fk = this.User.HalloId;
        if (this.addrHrn) {
          method = 'PUT';
          address.hrn_pk = this.addrHrn;
        } else {
          method = 'POST';
        }
        address = await this.User.requestResource('mis/address', method, address);
      } else if (this.addrHrn) {
        await this.User.requestResource('mis/address', 'DELETE', {
          hrn_pk: this.addrHrn
        });
        address = null;
      }
      let org:{[key:string] : any} = {
        user_fk: this.User.HalloId
      };
      let orgc=null, aor=null;
      let ssn = isString(this.nationalId) ? parseFloat(this.nationalId) : this.nationalId;
      if (this.userGroup==EUserGroup.Citizens) {
        method = 'PUT';
        org['ssn_pk'] = ssn;
        org['name_' + this.language] = this.name;
        org['surname_' + this.language] = this.surname;
        org['email'] = this.email;
        org['mobile'] = this.mobileNo;
        if (address && address.keyname && address[address.keyname]) {
          org.hrn_fk = address[address.keyname];
        } else {
          org.hrn_fk = null;
        }
        org = await this.User.requestResource('mis/farmer', method, org);
      } else {
        if (isObject(this.organization)) {
          method = 'PUT';
          org['code_pk'] = this.organization['code'];
          org['name_'+this.language] = this.organization['name'];
        } else {
          method = 'POST',
          org['name_'+this.language] = this.organization;
        }
        if (this.orgInitials) {
          org['abbr_' + this.language] = this.orgInitials || null;
        }
        if (address && address.keyname && address[address.keyname]) {
          org.hrn_fk = address[address.keyname];
        } else {
          org.hrn_fk = null;
        }
        org = await this.User.requestResource('mis/organization', method, org);
        orgc = org[org.keyname];
        aor = this.aorTown || this.aorCounty || this.aorProvince;
      }
      let user = {
        name_on: this.name,
        surname: this.surname,
        ssn: ssn,
        email: this.email,
        mobile: this.mobileNo,
        uname: this.userId,
        upswd: this.password,
        ugroup: this.userGroup,
        ustatus: EUserStatus.Active, // force to active, and wont send email for verification
        orgc_fk: orgc,
        aor_code: aor
      };
      user = await this.User.requestResource('user/register','POST', user);
      let $this = this;
      this.$store.commit('notifyChange', {
        Dialog: {
          Type: 'info',
          Title: 'registerUsers',
          Message: 'registerAnotherUser',
          OkText: 'yes',
          CancelText: 'no',
          wait: false,
          show: true,
          OnClose: (answer) => {
            if (answer=='ok') {
              $this.resetForm();
            } else {
              $this.listUsers();
            }
          }
        }
      });
    } catch (error) {
      this.$store.commit('notifyChange', {
        Dialog: {
          Type: 'error',
          Title: 'error',
          Message: error.message || 'Error during registration',
          OkText: null,
          CancelText: 'close',
          show: true,
          OnClose: null
        }
      });
    }
  }

  listUsers() {
    this.$emit('changeMenu',{
      name: 'admin'
    });
  }
}
